import { makeAutoObservable, action, observable } from 'mobx';
import formatPositionDetail from '@utils/formatPositionDetail';
import { getShareInfo } from '@service/share';
import { Toast } from '@ss/mtd-react-mobile';
import { LoginStore } from '@model/login';
import { isCampusFn } from '@utils/formatData';
import isDx from '@block/utils/lib/is/isDX';
import { getJobDetail, getDeliveryStatus } from '../service/positionDetail';

class JobDetail {
  @observable loading;

  @observable jobInfo;

  // canApply:true
  // # 是否可以投递
  // isApplied:true
  // # 是否投递过
  // isOnline:true
  // # 是否 非（已下架 网申截止日期过期）

  @observable statusData: any = {
    canApply: true,
    isApplied: false,
    isOnline: true,
  };

  constructor() {
    makeAutoObservable(this);
  }

  @action
  getInitData = async (params, go) => {
    if (this.loading) return;
    this.setLoading(true);
    const { isLoginFn, isLogin: isLogin2 } = LoginStore;
    // jobShareType:str
    // # 职位分享类型 1-新官网,2-社招伯乐,3-社招官网,4-校招伯乐,5-校招官网
    const { staffSsoId, jobShareType = '1', token } = params;
    const newParams = {
      jobShareType,
      staffSsoId,
      token,
    };
    let isLogin = isLogin2;
    if (!isLogin) {
      isLogin = await isLoginFn();
    }
    if (isLogin) {
      const [data, statusData] = await Promise.all([
        getJobDetail({
          jobUnionId: params?.jobUnionId,
          jobShareType: jobShareType || '1',
        }),
        getDeliveryStatus({
          jobId: params?.jobUnionId,
        }),
      ]);
      this.setJobInfo(formatPositionDetail(data));
      this.setStatusData(statusData);
      // this.statusData = statusData;
      this.setLoading(false);
    } else {
      const data = await getJobDetail({
        jobUnionId: params?.jobUnionId,
        jobShareType: jobShareType || '1',
      });
      this.setJobInfo(formatPositionDetail(data));
      this.setLoading(false);
    }
    if ((token || staffSsoId) && !isDx()) {
      // 非伯乐侧
      const shareInfo = await getShareInfo(newParams);
      // 链接失效跳转
      const { isApplied, isVolunteerFull, haveIntentionJob } = this.statusData || {};
      const isCampus = isCampusFn(this.jobInfo?.jobSpecialCode);
      const isView = (isVolunteerFull || !haveIntentionJob || isApplied) && isCampus && isLogin;
      // 校招查看申请(true)按钮过来的不需要跳转，立即申请需要(false)
      if (!shareInfo?.isEffective && !isView) {
        Toast.show({
          content: '该链接已失效，即将跳转到美团招聘官网首页',
          duration: 3000,
        });
        setTimeout(() => {
          go('/home', { replace: true });
        }, 2000);
        this.setLoading(false);
      }
    }
  };

  @action
  setJobInfo = (jobInfo) => {
    this.jobInfo = jobInfo;
  };

  @action
  setLoading = (value) => {
    this.loading = value;
  };

  @action
  setStatusData = (data) => {
    this.statusData = data;
  };
}

const JobDetailStore = new JobDetail();

export default JobDetailStore;
